<template>
  <fileSelector @finish="onFinish" fileType="audio"/>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import fileSelector from "@client/components/file-selector";

export default {
  name: "attr-qk-bg-music",
  props: {
  },
  components: {
    fileSelector
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  watch: {},
  computed: {
    ...mapState({
      editActiveElement: state => state.editor.editActiveElement
    }),
    ...mapGetters([
        'activePage'
    ]),
  },
  methods: {
      onFinish(fileInfo) {

          if (fileInfo === null) {
              this.handleCloseDialog() 
            return;   
          }

          let findResult = this.activePage.elements.some(element => {
            if (element.uuid === this.editActiveElement.uuid) {
                element.propsValue.musicSrc = fileInfo.file_url;
                return true;
            }

            return false;
        });

        if (!findResult) {
            let newEle = _.cloneDeep(this.editActiveElement);
            newEle.propsValue.musicSrc = fileInfo.file_url;
            this.activePage.elements.push(newEle);
        }

        this.$store.commit('addHistoryCache')
        this.handleCloseDialog();
      },
    handleCloseDialog() {
      this.$store.dispatch('editActiveElement', null);
    }
  }
}
</script>

<style scoped>
</style>
